/** Shared JSON helpers for hand-written API response types. */

export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonObject | JsonValue[];
export type JsonObject = { [key: string]: JsonValue };

/**
 * Opaque API payload during the hand-written ratchet.
 * Prefer tightening to a concrete interface when a fixture/contract exists.
 * Index signature uses `any` so existing page property access stays green.
 */
export type ApiData = { [key: string]: any };

export interface ApiSuccessMessage {
  success?: boolean;
  message?: string;
  detail?: string;
  [key: string]: any;
}

export interface ApiErrorBody {
  detail?: string | JsonValue;
  message?: string;
}

/** Parse a Response body as JSON typed as T (compile-time only). */
export async function parseJson<T = ApiData>(res: Response): Promise<T> {
  return res.json() as Promise<T>;
}

/** Runtime key presence check for contract fixtures (not a full schema validator). */
export function assertKeys(
  value: unknown,
  required: string[],
  label = "fixture",
): asserts value is ApiData {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    throw new Error(`${label}: expected object`);
  }
  const obj = value as ApiData;
  for (const key of required) {
    if (!(key in obj)) {
      throw new Error(`${label}: missing key "${key}"`);
    }
  }
}
